import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import TopMenu from '../../../contexts/TopMenu';
import { getOutfitApiEnv, setOutfitApiEnv } from '../../../services/outfitAdminApi';
import '../../../styles/OutfitAdmin.css';

function OutfitAdminLayout({ email, onLogout, pageTitle, children }) {
  const location = useLocation();
  const [selectedEnv, setSelectedEnv] = useState(getOutfitApiEnv());

  useEffect(() => {
    const handleEnvChange = (e) => {
      if (e.detail?.env) {
        setSelectedEnv(e.detail.env);
      }
    };
    window.addEventListener('outfit-env-changed', handleEnvChange);
    return () => window.removeEventListener('outfit-env-changed', handleEnvChange);
  }, []);

  const handleToggleEnv = (env) => {
    if (env === selectedEnv) return;
    setOutfitApiEnv(env);
    setSelectedEnv(env);
    // Reload page to refresh all active queries against the newly selected backend
    window.location.reload();
  };

  const getBreadcrumbTitle = () => {
    if (location.pathname.includes('/keywords-blacklist')) return 'Keywords Blacklist';
    if (location.pathname.includes('/cci-blacklist')) return 'Category Combination (CCI) Blacklist';
    if (location.pathname.includes('/trends/new')) return 'Outfit Trend Builder > New Trend';
    if (location.pathname.includes('/trends')) return 'Outfit Trend Builder';
    if (location.pathname === '/outfits' || location.pathname.includes('/get-started')) return 'Get Started';
    return pageTitle || 'Dashboard';
  };

  const isGetStartedActive =
    location.pathname === '/outfits' ||
    location.pathname === '/outfits/' ||
    location.pathname.includes('/get-started');

  return (
    <div className="outfit-admin-root">
      <TopMenu pageTitle="Outfit Studio Admin" email={email} onLogout={onLogout} />
      <main className="outfit-admin-main">
        <div className="outfit-header">
          <div>
            <div className="outfit-breadcrumb">
              <span>Admin</span>
              <span className="outfit-breadcrumb-sep">/</span>
              <span>Outfit Studio</span>
              <span className="outfit-breadcrumb-sep">/</span>
              <span className="outfit-breadcrumb-current">{getBreadcrumbTitle()}</span>
            </div>
            <h1>{pageTitle || 'Outfit Admin'}</h1>
          </div>
        </div>

        <div className="outfit-nav-tabs-bar">
          <nav className="outfit-nav-tabs" aria-label="Outfit Admin Navigation">
            <NavLink
              to="/outfits/get-started"
              className={() =>
                `outfit-nav-tab ${isGetStartedActive ? 'active' : ''}`
              }
            >
              <span>Get Started</span>
            </NavLink>
            <NavLink
              to="/outfits/keywords-blacklist"
              className={({ isActive }) =>
                `outfit-nav-tab ${isActive ? 'active' : ''}`
              }
            >
              <span>Keywords Blacklist</span>
            </NavLink>
            <NavLink
              to="/outfits/cci-blacklist"
              className={({ isActive }) =>
                `outfit-nav-tab ${isActive ? 'active' : ''}`
              }
            >
              <span>CCI Blacklist</span>
            </NavLink>
            <NavLink
              to="/outfits/trends"
              className={({ isActive }) =>
                `outfit-nav-tab ${
                  isActive || location.pathname.includes('/outfits/trends')
                    ? 'active'
                    : ''
                }`
              }
            >
              <span>Trend Builder</span>
            </NavLink>
          </nav>

          <div className="outfit-env-toggle-wrapper">
            <span className="outfit-env-toggle-label">API Env:</span>
            <div className="outfit-env-toggle-group" role="group" aria-label="Target API Environment">
              <button
                type="button"
                className={`outfit-env-toggle-btn ${selectedEnv === 'apidev' ? 'active' : ''}`}
                onClick={() => handleToggleEnv('apidev')}
                title="Connect to https://apidev.polopan.com"
              >
                <span className="outfit-env-dot" />
                apidev
              </button>
              <button
                type="button"
                className={`outfit-env-toggle-btn ${selectedEnv === 'apiv2' ? 'active' : ''}`}
                onClick={() => handleToggleEnv('apiv2')}
                title="Connect to https://apiv2.polopan.com"
              >
                <span className="outfit-env-dot" />
                apiv2
              </button>
            </div>
          </div>
        </div>

        {children}
      </main>
    </div>
  );
}

export default OutfitAdminLayout;
